export enum DocumentsGroupType {
  RG = 'RG',
  DRE = 'DRE',
  SELFIE = 'selfie',
  INCOME_TAX = 'incomeTax',
  ADDITIONAL = 'additional',
  BALANCE_SHEET = 'balanceSheet',
  COMPANY_PHOTO = 'companyPhoto',
  COMPANY_VIDEO = 'companyVideo',
  BANK_STATEMENT = 'bankStatement',
  SIMPLES_NACIONAL = 'simplesNacional',
  ARTICLES_OF_INCORPORATION = 'articlesOfIncorporation'
}

export enum DocumentType {
  photo = 'photo',
  video = 'video',
  document = 'document'
}

export enum DocumentAnalysisStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REQUESTED = 'requested',
  PENDING_ANALYSIS = 'pendingAnalysis'
}

export enum ContentType {
  CSV = 'text/csv',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  MP4 = 'video/mp4',
  MPG = 'video/mpeg',
  AVI = 'video/x-msvideo',
  PDF = 'application/pdf',
  ZIP = 'application/zip',
  PLAIN_TEXT = 'text/plain',
  OCTET_STREAM = 'application/octet-stream'
}

export enum S3UploadType {
  UPLOAD_SEND_ACCOUNT_DOCUMENT = 'uploadSendAccountDocument'
}
